import React, { Children, cloneElement, isValidElement, JSXElementConstructor, ReactElement, ReactNode } from "react";

import { Props as StepProps } from "./Step";
import styles from "./StepIndicator.module.scss";

type StepComponent = ReactElement<StepProps, string | JSXElementConstructor<StepProps>>;

interface Props {
  children: ReactNode;
  activeStepIndex: number;
  handleClick?: (index: number) => () => void;
}

export const StepIndicator = ({ children, activeStepIndex, handleClick }: Props) => {
  const childrenArray = Children.toArray(children).filter<StepComponent>(isValidElement);

  const steps = childrenArray.map((step, index) => {
    const isCompleted = activeStepIndex > index;
    return cloneElement(step, {
      isActive: activeStepIndex === index,
      isCompleted,
      handleClick: isCompleted && handleClick ? handleClick(index) : undefined,
      ...step.props,
    });
  });

  return (
    <section className={styles.stepIndicator__wrapper}>
      <nav id="step-indicator" aria-label="progress">
        <ol aria-labelledby="step-indicator">{steps}</ol>
      </nav>
    </section>
  );
};
